import { supabase } from '@/lib/supabase';
import type { TeamMember } from '@/types/db';

export async function getTeam(visibleOnly = false): Promise<TeamMember[]> {
  let query = supabase.from('team_members').select('*').order('sort_order', { ascending: true });
  if (visibleOnly) query = query.eq('visible', true);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

export async function upsertTeamMember(member: Partial<TeamMember> & { id: string }): Promise<TeamMember> {
  const { data, error } = await supabase.from('team_members').upsert(member).select().single();
  if (error) throw error;
  return data;
}

export async function deleteTeamMember(id: string): Promise<void> {
  const { error } = await supabase.from('team_members').delete().eq('id', id);
  if (error) throw error;
}
